import { useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { remittanceListSchema } from '../../../common/validations/remittance'

import { get } from 'api/apiClient'

const params = (uuid: string) => ({
  queryKey: [`${API_ENDPOINTS.CONTRACTS}/${uuid}/remittances`],
  queryFn: () =>
    get(`${API_ENDPOINTS.CONTRACTS}/${uuid}/remittances`, remittanceListSchema),
})

export const useAPIGetContractRemittances = (contractUUID: string) =>
  useQuery(params(contractUUID))

export const useAPIGetContractRemittancesSuspense = (contractUUID: string) =>
  useSuspenseQuery(params(contractUUID))
